import type { ValueFormatterParams } from 'ag-grid-community'

type Quantity = { number?: unknown; unit?: unknown }
type Price = { amount?: unknown; currency?: unknown }

const isString = (v: unknown): v is string => typeof v === 'string'

export const toNumberOrNull = (value: unknown): number | null => {
  if (value === '' || value === null || value === undefined) return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  const normalized = String(value).replace(',', '.').trim()
  const n = Number(normalized)
  return Number.isFinite(n) ? n : null
}

const formatCurrency = (value: number, currency?: string): string => {
  try {
    const currencyCode = currency ?? 'EUR'
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  } catch {
    return value.toString()
  }
}

export const formatQuantityValue = (params: ValueFormatterParams): string => {
  const unitRaw = (params.data as { quantity?: Quantity } | undefined)?.quantity
    ?.unit
  const unit = isString(unitRaw) && unitRaw.length > 0 ? unitRaw : 'u'

  const value = params.value
  if (value === '' || value === null || value === undefined) return '-'
  return unit ? `${value} ${unit}` : String(value)
}

export const formatPriceValue = (params: ValueFormatterParams): string => {
  // Keep 0 visible; only treat null/undefined/'' as empty
  if (params.value === null || params.value === undefined || params.value === '')
    return '-'

  const amount = toNumberOrNull(params.value)
  if (amount === null) return '-'

  const currency = (params.data as { price?: Price } | undefined)?.price?.currency
  return formatCurrency(amount, isString(currency) ? currency : undefined)
}

